export const app_i18n = {
  text1:
    "Scansiona il retro della tua carta d'identità o la pagina del passaporto in cui si trova la tua foto",
  text2: "Hai problemi con lo scanner?",
  text3: "Riprova",
  text4: "Processo manuale",
  text5: "Benvenuto!!",
  text6: "Seleziona la data del soggiorno",
  text7: "La tua email",
  text8: "Continua",
  text9: "Andiamo!, quasi finito",
  text10: "Benvenuto",
  text11: "Benvenuto",
  text12: "Telefono",
  text13:
    "Per continuare con il processo devi accettare i nostri termini e condizioni.",
  text14: "Accetto i termini e le condizioni",
  text15: "Continua",
  text16: "Puoi firmare nel riquadro grigio che vedi sullo schermo",
  text17: "Cancella",
  text18: "Salva firma",
  text19: "Scrivi la tua firma",
  text20: "Check-in completato con successo",
  text21:
    "Grazie mille, abbiamo inviato una copia del documento firmato al tuo WhatsApp",
  text22: "Devi effettuare un altro check-in?",
  text23: "Ricomincia",
  text24: "Benvenuto  🤗",
  text25: "😃 Inserisci i seguenti dati",
  text26: "Nome",
  text27: "Cognome",
  text28: "Seleziona il sesso",
  text29: "Sesso",
  text30: "Maschio",
  text31: "Femmina",
  text32: "Data di nascita",
  text33: "Andiamo!, ci siamo quasi 😉",
  text34: "Seleziona la data del soggiorno.",
  text35: "Email",
  text36: "Inserisci il documento",
  text37: "Tipo di documento",
  text38: "Documento",
  text39: "PASSAPORTO",
  text40: "Inserisci il numero del documento",
  text41: "Devi selezionare un paese",
  // here
  text42: "Paesi",
  text43: "Elenco dei servizi disponibili dell'alloggio",
  text44: "Caricamento servizi ...",
  text45: "Nessun servizio disponibile",
  text46: "Richiesta di servizio inviata con successo",
  text47: "Un operatore ti contatterà per finalizzare la richiesta di servizio.",
  text48: "Indietro",
  text49:
    "Richiesta di servizio inviata con successo, sarai contattato a breve da un supervisore.",
  text50: "Prezzo",
  text51: "Descrizione del servizio",
  text52: "Richiedi",
  text53: "Invia richiesta di servizio",
  text54: "Inviando la richiesta, un supervisore ti contatterà",
  text55: "Invia",
  text56: "Richiesta di servizio inviata con successo.",
  text57: "Errore, impossibile richiedere il servizio",
  text58: "Invio dei dati del check-in, attendi...",
  text59: "Caricamento...",
  text60: "ha completato il check-in con successo.",
  text61: `🎁 Clicca qui per vedere tutti i nostri servizi disponibili in hotel`,
  text62: "Registrazione dell'ingresso",
  text63: "Preferisco non dirlo",
  text64: "Altro",
  text65: "Paese",
  text66: "Errore",
  text67: "Alloggio disattivato.",
  text68: "Il proprietario ha disattivato i check-in.",
  text69: "Seleziona la data",
  text70: "Da - A",
  text71: "Seleziona un'opzione",
  text72: "Seleziona il paese *",
  text73: "Sei sicuro di voler riavviare il processo",
  text74: "Perderai i dati salvati",
  text75: "Dati del check-in",
  text76: "Firma del check-in",
  text77: "Firmato",
  text78: "Benvenuto",
  text79: "Spiacenti, si è verificato un errore durante la disconnessione",
  text80: "Annulla il processo.",
  text81:
    "La creazione del primo alloggio è obbligatoria per il corretto funzionamento del sistema.",
  text82: "Annulla ed esci",
  text83: "Continua con la modifica",
  text84: "Cerca...",
  text85: "Nessun record trovato",
  text86: "Precedente",
  text87: "Successivo",
  text88: "Vuoi riprovare o eseguire il processo manuale?",
  text89: "Caricamento ...",
  text90: "Servizi",
  text91: "Data di rilascio del documento",
  text92: "Il campo Data di rilascio del documento è obbligatorio",
  p93: `caricamento dei tuoi...`,
  p94: `Dati della prenotazione`,
  p95: `Benvenuto`,
  p96: `Per continuare con il check-in inserisci i seguenti
    dati:`,
  p97: `Questo processo è una dimostrazione, nessuno dei tuoi dati verrà salvato`,
  p98: `Codice di sicurezza:`,
  p99: `Codice di sicurezza dell'alloggio`,
  p101: `Inserisci il codice di sicurezza`,
  p102: `Il codice di sicurezza non è corretto, verifica e prova di
    nuovo.`,
  p103: `Oppure puoi anche`,
  p104: `Filtra per codice di check-in`,
  p105: `Continua`,
  p106: `Codice di check-in`,
  p107: `Inserisci il codice di check-in`,
  p108: `Il codice di check-in non è registrato nella nostra piattaforma, verifica e riprova.`,
  p109: `Inserisci il codice dell'alloggio`,
  p110: `Check-in ecologico`,
  p111: `Benvenuto!`,
  p112: `Tieni a portata di mano il tuo`,
  p112_1: `documento o passaporto`,
  p112_2: `per procedere`,
  p113: `Dovrai accettare i`,
  p114: ` permessi della fotocamera 📷`,
  p115: ` sono necessari affinché il nostro scanner funzioni correttamente.`,
  p116: `Continua`,
  p117: `Seleziona la lingua`,
  p118: `Inserisci il codice di sicurezza`,
  p119: `Scansiona la pagina del passaporto o il retro della tua carta d'identità.`,
  p120: `Carta d'identità`,
  p121: `Documento`,
  p122: `o la pagina del passaporto in cui si trova la tua foto`,
  p123: `Per utilizzare lo scanner, è necessario concedere i permessi corrispondenti
    alla fotocamera.`,
  p124: `Verifica di sicurezza 🔐`,
  p125: `Per verificare il tuo numero abbiamo inviato un codice al tuo`,
  p126: `WhatsApp`,
  p127: `Inseriscilo qui:`,
  p128: `Inserisci il codice`,
  p129: `Codice errato, verifica e riprova`,
  p130: `Indietro`,
  p131: `Continua`,
  p132: `Data di arrivo`,
  p133: `Data di partenza`,
  p134: `Data di scadenza`,
  p135: `Nazionalità`,

  p136: `Cliccando`,
  p137: ` accetti di firmare il modulo con il tuo nome, il contratto di locazione a breve termine`,
  p138: `Informative sulla privacy`,
  p139: `Salva firma`,
  p140: `Informazioni sulla prenotazione`,
  p141: `PRENOTAZIONE:`,
  p142: `Arrivo`,
  p143: `Partenza`,
  p144: `Paga`,
  p145: `Pagato`,
  p146: `Verifica del pagamento in corso`,
  p147: `Check-in`,
  p148: `Prenotazione`,
  p149: `Servizi`,
  p150: `VERIFICA DELL'IDENTITÀ`,
  p151: `Carica un selfie del tuo viso, con una buona illuminazione`,
  p152: `In questa schermata puoi caricare una foto del <strong>fronte del tuo documento`,
  p153: `In questa schermata puoi caricare una foto del <strong>retro del tuo documento`,
  p154: `Apri la fotocamera`,
  p155: `Scatta di nuovo`,
  p156: `Verifica l'identità`,
  p157: `Continua`,
  p158: `Errore durante la verifica della tua identità.`,
  p159: `Riprova.
    Puoi scattare le foto in un'area ben illuminata e centrare correttamente il documento.`,
  p160: `Processo obbligatorio*`,
  p161: `Riprova`,
  p162: `Verifica dell'identità in corso.`,
  p163: `Attendi ....`,
  p164: `Identità verificata con successo`,
  p165: `Hai verificato la tua identità 🪪 con successo, il processo di check-in è quasi completato 😎`,
  p166: `Da consultare`,
  p167: `Per richiedere questo servizio devi effettuare il check-in.`,
  p168: `Avanzamento`,
  p169: `Data di scadenza del documento`,
  p170: `Data di arrivo`,
  p171: `Data di partenza`,
  p172: `Telefono`,
  p173: `Non è stato possibile scansionare il tuo documento.`,
  p174: `L'indirizzo non appartiene a una prenotazione nel sistema`,
  p175: `Informazioni sul check-in`,
  p176: `Assistenza`,
  p177: `Spagnolo (Spagna)`,
  p178: `Inglese`,
  p179: `Arabo`,
  p180: `Documento`,
  p181: `Passaporto`,

  p182: `Seleziona il grado di parentela`,
  p183: `Figlio/Figlia`,
  p184: `Nonno/Nonna`,
  p185: `Bisnonno/Bisnonna`,
  p186: `Pronipote/Pronipote`,
  p187: `Cognato/Cognata`,
  p188: `Coniuge`,
  p189: `Fratello/Sorella`,
  p190: `Nipote/Nipote`,
  p191: `Altro`,
  p192: `Padre o Madre`,
  p193: `Nipote/Nipote`,
  p194: `Suocero/Suocera`,
  p195: `Zio/Zia`,
  p196: `Tutore`,
  p197: `Genero/Nuora`,

  p198: `Il campo del grado di parentela è obbligatorio`,
  p199: `Documento`,
  p200: `ALTRO`,
  p201: `Numero di supporto del documento`,
  p202: `Il numero di supporto del documento è obbligatorio`,

  p203: `Informazioni richieste ai sensi del Regio Decreto 933/2021`,
  p204: `Ai sensi del Regio Decreto 933/2021, del 26 ottobre, dobbiamo raccogliere dati come il tuo indirizzo, il codice postale, il metodo di pagamento e la data di pagamento per rispettare le normative di sicurezza.`,
  p205: `Indirizzo di residenza attuale`,
  p206: `Indirizzo`,
  p207: `Codice postale`,
  p208: `Metodo di pagamento`,
  p209: `Seleziona un metodo di pagamento`,
  p210: `Contanti`,
  p211: `Pagamento all'arrivo`,
  p212: `Carta di credito`,
  p213: `Pagamento da mobile`,
  p214: `Piattaforma di pagamento`,
  p215: `Carta regalo`,
  p216: `Bonifico`,
  p217: `Data di pagamento`,
  p218: `Metodo di pagamento`,
  p219: `Data di pagamento`,
  p220: "Paese di residenza",
  p221: "Città di residenza",
  p222: "Indirizzo di residenza",
  p223: "Codice postale di residenza",

  p224: "Seleziona un'opzione",
  p225: "Ci sono minori nella prenotazione?",
  p226: "No",
  p227: "Sì",
  p228: "Documento non consentito",
  p229: "Verifica e utilizza il tuo passaporto valido per continuare.",
  p230:`Scansiona il tuo passaporto o la tua carta d'identità`,

  p231: `La data di partenza non può essere anteriore alla data di arrivo`,
  p232: `Indirizzo email valido`,
  p233: `Campo obbligatorio`,
  p234: `Il numero del documento non è valido`,
  p235: `La data di partenza non può essere anteriore alla data di partenza`,
  p236: `Devi specificare se ci sono bambini nella prenotazione`,
  p237: `Devi selezionare il grado di parentela quando ci sono bambini nella prenotazione`,
  p238: `Errore, il processo non può continuare`,
  p239: `Benvenuto!`,
  p240: `Tieni a portata di mano il tuo`,
  p241: `documento o passaporto`,
  p242: `🪪 pronto per il processo automatizzato`,
  p243: `Nota bene`,
  p244: `Accettare i permessi della fotocamera 📷`,
  p245: `è necessario affinché il nostro scanner funzioni correttamente`,
  p246: `Scansiona il retro del tuo`,
  p247: `Completa qui la registrazione del tuo check-in!`,
  p248: `Link copiato negli appunti`,
  p249: `Registra un altro ospite`,
  p250: `WhatsApp`,
  p251: `Copia link`,
  p252: `Metodo di pagamento sconosciuto`,
  p253: `Il codice postale non è stato trovato nei registri`,
  p254: `Esperienze e servizi`,
  p255: `Tutto ciò di cui hai bisogno per goderti appieno il tuo soggiorno`,
};
